var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none","position":"fixed","top":"0","left":"0","z-index":"999999","background":"#fff"}},[_c('div',{ref:"canvasRef",attrs:{"width":"1000","height":"1000"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-294bcac4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Render/CalendarCanvas.vue
// module id = 470
// module chunks = 0